import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // if ([401, 403].includes(err.status)) {
            //     // auto logout if 401 or 403 response returned from api
            //     console.error(err);
            // }
            
            // if ([200, 201].includes(err.status)) {
            //     // auto logout if 401 or 403 response returned from api
            //     console.error(err);
            // }

            if([500].includes(err.status)) {
                // console.error(err);
                return throwError(err?.error?.error?.message);
            }
            else if([404].includes(err.status)) {
                // console.log(err)
                return throwError(err?.error ? err?.error : err?.statusText);
            }
            else{
                const error = err.error?.message || err.error?.login_failure || err.error?.text || err.statusText ;
                // console.error(err);
                return throwError(error); 
            }
        }))
    }
}
